import { type ReactNode } from 'react'
import { CardContent } from '@/components/Card'
import { Button } from '@/components/Button'

export interface JobStartedRetailOutsourcingActionsProps {
  isAnyExtensionFlowAvailable: boolean
  hasDraftReturn: boolean
  isDraftReturnDownloadable: boolean
  requestDraftApprovalLabel: string
  onReportOpenItems: () => unknown
  onRequestDraftApproval: () => unknown
  extensionActions?: ReactNode
}

export function JobStartedRetailOutsourcingActions({
  isAnyExtensionFlowAvailable,
  hasDraftReturn,
  isDraftReturnDownloadable,
  requestDraftApprovalLabel,
  onReportOpenItems,
  onRequestDraftApproval,
  extensionActions,
}: JobStartedRetailOutsourcingActionsProps) {
  return (
    <>
      <CardContent compactBottomPadding>
        <Button
          label="Report Open Items"
          variant="secondary"
          size="wide-slim"
          onPress={onReportOpenItems}
          testId="job-progression-set-open-items-button"
        />
      </CardContent>
      <CardContent compactBottomPadding={isAnyExtensionFlowAvailable}>
        <Button
          label={requestDraftApprovalLabel}
          variant="primary"
          size="wide-slim"
          isDisabled={hasDraftReturn && !isDraftReturnDownloadable}
          onPress={onRequestDraftApproval}
          testId="job-progression-set-draft-in-review-button"
        />
      </CardContent>

      {extensionActions}
    </>
  )
}

export interface JobStartedEssentialActionsProps {
  onUploadDocuments: () => unknown
  testId?: string
}

export function JobStartedEssentialActions({
  onUploadDocuments,
  testId,
}: JobStartedEssentialActionsProps) {
  return (
    <CardContent>
      <Button
        label="Upload Documents"
        variant="primary"
        size="wide-slim"
        onPress={onUploadDocuments}
        testId={testId}
      />
    </CardContent>
  )
}

export interface JobStartedPreparationActionsProps {
  isAnyExtensionFlowAvailable: boolean
  onReportOpenItems: () => unknown
  onPreparationCompleted: () => unknown
  extensionActions?: ReactNode
}

export function JobStartedPreparationActions({
  isAnyExtensionFlowAvailable,
  onReportOpenItems,
  onPreparationCompleted,
  extensionActions,
}: JobStartedPreparationActionsProps) {
  return (
    <>
      <CardContent compactBottomPadding>
        <Button
          label="Report Open Items"
          variant="secondary"
          size="wide-slim"
          onPress={onReportOpenItems}
          testId="job-progression-set-open-items-button"
        />
      </CardContent>
      <CardContent compactBottomPadding={isAnyExtensionFlowAvailable}>
        <Button
          label="Preparation Completed"
          variant="primary"
          size="wide-slim"
          onPress={onPreparationCompleted}
          testId="job-progression-set-upload-notes-button"
        />
      </CardContent>

      {extensionActions}
    </>
  )
}
